import React from 'react'
import './App.css'
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import LoginPage from './pages/loginPage'
import HomePage from './pages/homePage'
import Page404 from './pages/Page404'

import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { M_Router } from './M_Components'
import { SignalRProvider } from './services/signalRContext';

export default function App() {

  const endpoints = [
    "listUsers",
    "company",
    "booking",
    "bl",
    "transport",
    "shipment",
    "bookingEquipment",
    "BookingEquipment",
    "Equipment",
    "equipmentType",
    "EquipmentType",
    "account",
    "Account",
    "voyage",
    "commodity",
    "Commodity",
    "package",
    "Package",
    "trade",
    "Trade",
    "Transport",
    "dangerousGoods",
    "DangerousGoods",
    "location",
    "ServiceType",
    "Movement",
    "Demurrage",
    "DemurrageRule",
    "DemurrageControl",
    "EquipmentStatus",
    "EquipmentClass",
    "EquipmentClassSentence",
    "EquipmentType",
    "EquipmentService",
    "EquipmentLeasing",
    "EquipmentCondition",
    "MovementType",
    "MovementTypeEquipmentStatus",
    "MovementLink",
    "Transport",
    "TransportMeans",
    "EquipmentCostRule",
    "EquipmentCostDetail",
    "Location",
    "Country",
    "transportClause",
    "quote",
    "Currency",
    "ServiceType",
    "quoteDetail",
    "LumpSum",
    "receivable",
    "voyage",
    "exchange",
    "ShipmentCharges",
    "shipment",
    "Shipment",
    "equipmentClass",
    "LocationRestriction",
    "Location"
  ]

  return (
    <M_Router
      primaryColor={'var(--color-blue)'}
      secondaryColor={'var(--color-blue-dark)'}
      tertiaryColor={'var(--color-blue-light)'}
      endpoints={endpoints}
      Routing={
        <SignalRProvider>
          <Router>
            <Routes>
              {
                localStorage.getItem("tokenMaeil") ?
                  <Route path="/" element={<Navigate to="/home" />} />
                  :
                  <Route path="/" element={<Navigate to="/login" />} />
              }
              <Route
                path="*" element={<Page404 />} />
              <Route
                path="/home/*" element={<HomePage />} />
              <Route
                path="/login" element={<LoginPage />} />
            </Routes>
          </Router>
        </SignalRProvider>

      }
    />
  )
}